/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Studio_LedeInputs */

const en_home_studio_lede = /** @type {(inputs: Home_Studio_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We map the process, build the software and the agents, and run the system with you after launch.`)
};

const lv_home_studio_lede = /** @type {(inputs: Home_Studio_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iepazīstam procesu, izstrādājam programmatūru un aģentus, un pēc palaišanas sistēmu uzturam kopā ar Jums.`)
};

/**
* | output |
* | --- |
* | "We map the process, build the software and the agents, and run the system with you after launch." |
*
* @param {Home_Studio_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_studio_lede = /** @type {((inputs?: Home_Studio_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Studio_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_studio_lede(inputs)
	return en_home_studio_lede(inputs)
});